export default {
  400: '请求错误(400)',
  401: '未授权，请重新登录(401)',
  403: '拒绝访问(403)',
  404: '请求出错(404)',
  408: '请求超时(408)',
  500: '服务器错误',
  501: '服务未实现(501)',
  502: '网络错误(502)',
  503: '服务不可用(503)',
  504: '网络超时(504)',
  505: 'HTTP版本不受支持(505)',
  120021: '请输入正确ICCID信息',
  120019: '激活码不正确',
  120015: '系统找不到订单，请重新核对订单信息',
  120016: '系统找不到订单，请重新核对订单信息',
  120014: '卡已经激活，请勿重复激活',
  120018: 'SIM卡已过期，无法激活',
  120020: 'SIM卡激活中，请耐心等待',
  120078: '请输入正确的购卡订单号',
  120079: '当前无主套餐，无法订单流量包',
  120080: '当前已存在待生效套餐，无法订购主套餐',
  120000: '文件过大，单个文件不超过4MB',

  // 90008: '用户名或密码错误',
  // ':10000': '验证码错误',

  9001: '抽奖活动不存在',
  9002: '活动已结束',
  9003: '奖品库存不足',
  9005: '抽奖中，请稍等',
  9008: '抽奖次数已用完',
  9013: '输入正确的edu邮箱',
  9014: '验证码次数发送过多，1小时内最多发送5次',
  9015: '无权操作，需要先获取验证码',
  9016: '用户没有中奖记录',
  9999: '抽奖人数太多，请稍后再试'
};
